<template>
  <div class="container">
    <div class="d-flex flex-row justify-between">
      <Search
        v-model="query"
        :focus="true"
        :inside-card="true"
        @search="fetchAutomatedTags(true)"
        @clearSearch="fetchAutomatedTags"
        class="mb20"
      />
    </div>
    <div class="card clearfix">
      <DataTable
        ref="table"
        :loading="loadingFirstPage"
        :data="tableData"
        :updatingRow="updatingRowId"
      />
      <div v-if="loadingNextPage" class="pt40 pb40">
        <Loader  />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import { FIELD_TYPE } from '../../config/const';
import DataTable from '../datatable';
import Search from '../Search';
import Loader from '../loader';

export default {

  data: () => {
    return {
      updatingRowId: null,
      pagination: {
        page: 1,
        perPage: 20,
        order: 'id',
        sort: 'asc'
      },
      data: [],
      isBusy: false,
      loadMore: false,
      query: ''
    }
  },

  computed: {
    tableData () {
      return {
        columns: [
          { key: 'category', label: this.$i18n.t('tag.labels.category.title'), orderable: true, sortTooltip: this.$i18n.t('tag.sort.alphabetical') },
          { key: 'name', label: this.$i18n.t('tag.labels.name.title'), orderable: true, sortTooltip: this.$i18n.t('tag.sort.alphabetical') },
          { key: 'alias', label: this.$i18n.t('tag.labels.alias.title'), orderable: true, sortTooltip: this.$i18n.t('tag.sort.alphabetical'),
            input: {
              type: FIELD_TYPE.INPUT,
              name: 'alias',
              placeholder: this.$i18n.t('tag.labels.alias.title'),
              onBlur: this.updateAlias,
              useDebounce: false
            }
          }
        ],
        body: this.data,
        order: {
          column: this.pagination.order,
          direction: this.pagination.sort,
          onChange: this.updatePagination
        }
      }
    },

    loadingFirstPage () {
      return this.isBusy && this.pagination.page === 1;
    },

    loadingNextPage () {
      return this.isBusy && this.pagination.page > 1;
    },

    projectId () {
      return this.$route.params.project_uid;
    },
  },

  methods: {
    updateAlias (value, key, row) {
      const val = value.trim();
      if (row[key] !== val) {
        this.updatingRowId = row.id;
        this.updateAutomatedTagAlias({ id: row.id, projectId: this.projectId, data: { [key]: val } }).then(r => {
          this.updatingRowId = null;
          if (r) {
            this.$notify({
              group: 'store_notifications',
              type: 'success',
              text: this.$t('tag.form.success.automated_tag_alias_updated'),
            });
          }
        });
      }
    },

    updatePagination (column, direction) {
      this.pagination = { ...this.pagination, order: column, sort: direction, page: 1 };
    },

    fetchAutomatedTags (resetPagination = false) {
      if (resetPagination) {
        this.pagination = { ...this.pagination, page: 1 };
        return;
      }
      this.isBusy = true;
      this.getAutomatedTags({ projectId: this.projectId, pagination: this.pagination, search: this.query }).then(r => {
        const data = r;
        if (this.pagination.page === 1) {
          this.data = data.data;
        } else {
          this.data = [...this.data, ...data.data];
        }
        this.loadMore = data.pagination.currentPage < data.pagination.totalPages;
      }).finally(() => {
        this.isBusy = false;
      });      
    },

    handleScroll () {
      if (this.loadMore && !this.isBusy) {
        const wHeight = window.innerHeight;
        const { top, height } = this.$refs.table.$el.getBoundingClientRect();
        const margin = 100;

        if (top * -1 + wHeight >= height - margin) {
          this.pagination = { ...this.pagination, page: this.pagination.page + 1 };
        }
      }
    },

    ...mapActions({
      getAutomatedTags: 'admin/automatedTags/getAutomatedTags',
      updateAutomatedTagAlias: 'admin/automatedTags/updateAutomatedTagAlias'
    }),
  },

  watch: {
    pagination () {
      this.fetchAutomatedTags();
    }
  },

  mounted () {
    this.fetchAutomatedTags();
    window.addEventListener('scroll', this.handleScroll);
  },

  beforeUnmount () {
    window.removeEventListener('scroll', this.handleScroll);
  },

  components: {
    DataTable,
    Search,
    Loader
  }
}
</script>